/* Avens theme — storefront scripts (no dependencies) */
(function () {
  'use strict';
  const A = window.Avens || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (A.routes && A.routes.root) || '/';

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || A.moneyFormat || '{{amount}}';
    const m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    const fmt = (n, d, ts = ',', ds = '.') => {
      n = (n / 100).toFixed(d);
      const p = n.split('.');
      return p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ts) + (p[1] ? ds + p[1] : '');
    };
    let v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      default: v = fmt(cents, 2);
    }
    if (document.documentElement.dataset.trim !== 'false') v = v.replace(/[.,]00$/, '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  A.formatMoney = formatMoney;

  function toast(msg) {
    const t = $('.toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(t._h); t._h = setTimeout(() => (t.hidden = true), 2600);
  }

  /* ---------- Cart ---------- */
  const Cart = {
    sectionIds() {
      const ids = ['cart-drawer', 'cart-bubble'];
      $$('[data-cart-section]').forEach(el => ids.push(el.dataset.cartSection));
      return ids;
    },
    async request(url, body) {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign({}, body, { sections: this.sectionIds(), sections_url: window.location.pathname }))
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || A.strings.error);
      return data;
    },
    render(sections) {
      if (!sections) return;
      const parse = html => new DOMParser().parseFromString(html, 'text/html');
      if (sections['cart-drawer']) {
        const doc = parse(sections['cart-drawer']);
        const fresh = $('#CartDrawerInner', doc), cur = $('#CartDrawerInner');
        if (fresh && cur) { const sc = $('.drawer__body', cur); const top = sc ? sc.scrollTop : 0; cur.replaceWith(fresh); const nb = $('#CartDrawerInner .drawer__body'); if (nb) nb.scrollTop = top; }
      }
      if (sections['cart-bubble']) {
        const doc = parse(sections['cart-bubble']);
        const n = $('[data-cart-count]', doc);
        if (n) $$('[data-cart-count]').forEach(el => (el.textContent = n.textContent));
      }
      $$('[data-cart-section]').forEach(el => {
        const html = sections[el.dataset.cartSection];
        if (!html) return;
        const fresh = $('[data-cart-section]', parse(html));
        if (fresh) el.innerHTML = fresh.innerHTML;
      });
      document.dispatchEvent(new CustomEvent('cart:updated'));
    },
    async add(items, opts = {}) {
      const data = await this.request(A.routes.cart_add + '.js', { items });
      if (opts.checkout) { window.location.href = root.replace(/\/$/, '') + '/checkout'; return data; }
      if (opts.source) { markAdded(opts.source); await flyToBag(opts.source); }
      this.render(data.sections);
      bumpBag();
      if (A.cartType === 'page' && !$('[data-cart-section]')) { window.location.href = A.routes.cart; return data; }
      if (opts.source) await new Promise(r => setTimeout(r, 250));
      this.open();
      return data;
    },
    async change(key, quantity) {
      const data = await this.request(A.routes.cart_change + '.js', { id: key, quantity });
      this.render(data.sections);
      return data;
    },
    async update(body) {
      const data = await this.request(A.routes.cart_update + '.js', body);
      this.render(data.sections);
      return data;
    },
    open() {
      const d = $('#CartDrawer'); if (!d) return;
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(() => { const c = $('.drawer__close', d); c && c.focus(); }, 50);
    },
    close() {
      const d = $('#CartDrawer'); if (!d) return;
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }
  };
  A.Cart = Cart;

  /* ---------- Button effects ---------- */
  function markAdded(btn) {
    if (!btn || !btn.hasAttribute('data-added')) return;
    btn.classList.remove('is-loading');
    const label = btn.querySelector('[data-atc-label]') || btn.querySelector('span:last-child') || btn;
    const old = label.textContent;
    btn.classList.add('is-added');
    label.textContent = btn.dataset.added;
    const ic = btn.querySelector('.btn__icon'); const oldIc = ic && ic.innerHTML;
    if (ic) ic.innerHTML = '<svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
    setTimeout(() => { btn.classList.remove('is-added'); label.textContent = old; if (ic) ic.innerHTML = oldIc; }, 1800);
  }
  function bagTarget() { return Array.from(document.querySelectorAll('.bag-btn')).find(b => b.offsetParent !== null); }
  function bumpBag() { const b = bagTarget(); if (!b) return; b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); }
  function flyToBag(btn) {
    return new Promise(resolve => {
      const bag = bagTarget();
      if (!A.flyToCart || !bag || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return resolve();
      const scope = btn.closest('.pcard, [data-product], .sticky-atc, .xcard, .upsell, .fbt') || document;
      const src = scope.querySelector('.gallery__slide.is-active img, .pcard__img, .sticky-atc__img img, .xcard__media img, .upsell__img img, img');
      const bagR = bag.getBoundingClientRect();
      if (!src) return resolve();
      const r = src.getBoundingClientRect();
      const size = Math.min(160, Math.max(60, r.width * 0.5));
      const clone = document.createElement('img');
      clone.src = src.currentSrc || src.src; clone.className = 'fly-img';
      const sx = r.left + r.width / 2 - size / 2, sy = r.top + r.height / 2 - size / 2;
      Object.assign(clone.style, { left: sx + 'px', top: sy + 'px', width: size + 'px', height: size + 'px' });
      document.body.appendChild(clone);
      const dx = bagR.left + bagR.width / 2 - (sx + size / 2), dy = bagR.top + bagR.height / 2 - (sy + size / 2);
      requestAnimationFrame(() => requestAnimationFrame(() => { clone.style.transform = `translate(${dx}px, ${dy}px) scale(.18) rotate(-12deg)`; clone.style.opacity = '.6'; clone.style.borderRadius = '50%'; }));
      setTimeout(() => {
        clone.remove();
        for (let i = 0; i < 8; i++) { const d = document.createElement('span'); d.className = 'drop-burst'; const a = (Math.PI * 2 * i) / 8; Object.assign(d.style, { left: bagR.left + bagR.width / 2 + 'px', top: bagR.top + bagR.height / 2 + 'px' }); d.style.setProperty('--dx', Math.cos(a) * 34 + 'px'); d.style.setProperty('--dy', Math.sin(a) * 34 + 'px'); document.body.appendChild(d); setTimeout(() => d.remove(), 750); }
        resolve();
      }, 760);
    });
  }
  // serum-drop ripple on buttons
  document.addEventListener('pointerdown', e => {
    const b = e.target.closest('[data-fx], .xcard__btn'); if (!b) return;
    const r = b.getBoundingClientRect(); const d = document.createElement('span');
    d.className = 'fx-drop'; d.style.left = (e.clientX - r.left) + 'px'; d.style.top = (e.clientY - r.top) + 'px';
    if (getComputedStyle(b).overflow !== 'hidden') b.style.overflow = 'hidden';
    b.appendChild(d); setTimeout(() => d.remove(), 700);
  });

  // Generic AJAX add forms (product cards, product page, sticky, upsell)
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    const btn = e.submitter || $('[type=submit]', form);
    const fd = new FormData(form);
    const items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }];
    const props = {};
    for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; }
    if (Object.keys(props).length) items[0].properties = props;
    if (fd.get('selling_plan')) items[0].selling_plan = fd.get('selling_plan');
    const checkout = btn && btn.hasAttribute('data-buy-now');
    btn && btn.classList.add('is-loading');
    try {
      await Cart.add(items, { checkout, source: btn });
    } catch (err) { toast(err.message); }
    finally { btn && btn.classList.remove('is-loading'); }
  });

  document.addEventListener('click', async (e) => {
    const t = e.target;
    if (t.closest('[data-cart-open]')) { if ($('#CartDrawer') && A.cartType === 'drawer') { e.preventDefault(); Cart.open(); } return; }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); Cart.close(); return; }
    const qb = t.closest('[data-line-qty]');
    if (qb) {
      e.preventDefault();
      const line = qb.closest('[data-line-key]');
      const input = $('input', qb.parentElement) || null;
      let q = Number(qb.dataset.lineQty);
      line && line.classList.add('is-loading');
      try { await Cart.change(line.dataset.lineKey, q); } catch (err) { toast(err.message); line && line.classList.remove('is-loading'); }
      return;
    }
    const quick = t.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault(); quick.classList.add('is-loading');
      try { await Cart.add([{ id: Number(quick.dataset.quickAdd), quantity: 1 }], { source: quick.closest('#CartDrawer') ? null : quick }); } catch (err) { toast(err.message); }
      finally { quick.classList.remove('is-loading'); }
      return;
    }
    const rmCode = t.closest('[data-remove-code]');
    if (rmCode) {
      e.preventDefault();
      const codes = $$('[data-code]').map(el => el.dataset.code).filter(c => c !== rmCode.dataset.removeCode);
      try { await Cart.update({ discount: codes.join(',') }); } catch (err) { toast(err.message); }
    }
  });

  document.addEventListener('change', async (e) => {
    const inp = e.target.closest('[data-line-input]');
    if (inp) {
      const line = inp.closest('[data-line-key]');
      line && line.classList.add('is-loading');
      try { await Cart.change(line.dataset.lineKey, Math.max(0, Number(inp.value))); } catch (err) { toast(err.message); }
    }
    const note = e.target.closest('[data-cart-note]');
    if (note) fetch(A.routes.cart_update + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  });

  // Discount code
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-apply-code]');
    if (!b) return;
    e.preventDefault();
    const input = $('[data-code-input]', b.closest('.summary') || document);
    const code = input && input.value.trim();
    if (!code) return;
    const existing = $$('[data-code]').map(el => el.dataset.code);
    b.classList.add('is-loading');
    try {
      const data = await Cart.update({ discount: existing.concat(code).join(',') });
      const applied = (data.discount_codes || []).find(d => d.code.toUpperCase() === code.toUpperCase());
      if (applied && !applied.applicable) toast(b.dataset.invalid || 'Code not applicable');
    } catch (err) { toast(err.message); }
    finally { b.classList.remove('is-loading'); }
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { Cart.close(); closeMenu(); closeVideo(); closeFacets(); } });

  /* ---------- Quantity steppers (product page) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const wrap = b.closest('.qty'); const input = $('input', wrap);
    const min = Number(input.min || 1);
    input.value = Math.max(min, Number(input.value || 1) + Number(b.dataset.qtyStep));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Announcement rotator ---------- */
  $$('[data-rotator]').forEach(el => {
    const msgs = $$('.announce__msg', el); if (msgs.length < 2) return;
    let i = 0; const ms = Number(el.dataset.rotator) * 1000;
    const show = n => { i = (n + msgs.length) % msgs.length; msgs.forEach((m, k) => m.classList.toggle('is-active', k === i)); };
    let t = ms ? setInterval(() => show(i + 1), ms) : null;
    const reset = () => { if (t) { clearInterval(t); t = setInterval(() => show(i + 1), ms); } };
    const p = $('[data-prev]', el), n = $('[data-next]', el);
    p && p.addEventListener('click', () => { show(i - 1); reset(); });
    n && n.addEventListener('click', () => { show(i + 1); reset(); });
  });

  /* ---------- Hero slider ---------- */
  function initSliders(scope = document) {
    $$('[data-slider]', scope).forEach(el => {
      if (el._init) return; el._init = true;
      const slides = $$('.hero__slide', el); if (!slides.length) return;
      let i = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));
      const ms = Number(el.dataset.slider) * 1000;
      const show = n => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      };
      let t = null; const start = () => { if (ms && slides.length > 1) { clearInterval(t); t = setInterval(() => show(i + 1), ms); } };
      el.addEventListener('click', e => {
        if (e.target.closest('[data-prev]')) { show(i - 1); start(); }
        else if (e.target.closest('[data-next]')) { show(i + 1); start(); }
        else { const d = e.target.closest('[data-go]'); if (d) { show(Number(d.dataset.go)); start(); } }
      });
      el.addEventListener('mouseenter', () => clearInterval(t));
      el.addEventListener('mouseleave', start);
      let x0 = null;
      el.addEventListener('touchstart', e => (x0 = e.touches[0].clientX), { passive: true });
      el.addEventListener('touchend', e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { const rtl = document.dir === 'rtl'; show(i + ((dx < 0) !== rtl ? 1 : -1)); start(); } x0 = null; });
      el.addEventListener('shopify:block:select', e => { const idx = slides.findIndex(s => s.contains(e.target) || s === e.target); if (idx > -1) { show(idx); clearInterval(t); } });
      start();
    });
  }
  initSliders();

  /* ---------- Scroller arrows ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-scroll]'); if (!b) return;
    const sc = document.getElementById(b.dataset.target); if (!sc) return;
    const dir = Number(b.dataset.scroll) * (document.dir === 'rtl' ? -1 : 1);
    sc.scrollBy({ left: dir * sc.clientWidth * 0.8, behavior: 'smooth' });
  });

    /* ---------- Footer accordions (mobile) + back to top ---------- */
  (function () {
    const accs = Array.from(document.querySelectorAll('[data-footer-acc]'));
    if (accs.length) {
      const mq = window.matchMedia('(max-width: 749px)');
      const sync = () => accs.forEach((d, i) => { if (mq.matches) { d.open = i === 0; } else { d.open = true; } });
      sync();
      mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
      accs.forEach(d => d.querySelector('summary').addEventListener('click', e => { if (!mq.matches) e.preventDefault(); }));
    }
    document.addEventListener('click', e => { if (e.target.closest('[data-back-top]')) window.scrollTo({ top: 0, behavior: 'smooth' }); });
  })();

  /* ---------- Wishlist (saved in this browser) ---------- */
  const WKEY = 'avens-wishlist';
  const wGet = () => { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (_) { return []; } };
  const wSet = l => { try { localStorage.setItem(WKEY, JSON.stringify(l)); } catch (_) {} wSync(); };
  function wSync() {
    const l = wGet();
    document.querySelectorAll('[data-wish]').forEach(b => { const on = l.includes(b.dataset.wish); b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    document.querySelectorAll('[data-wish-count]').forEach(c => { c.textContent = l.length; c.hidden = l.length === 0; });
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-wish]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    const h = b.dataset.wish; let l = wGet();
    l = l.includes(h) ? l.filter(x => x !== h) : [h].concat(l);
    wSet(l);
    const grid = b.closest('[data-wish-grid]');
    if (grid && !l.includes(h)) { const it = b.closest('.wish-item'); it && it.remove(); if (!grid.children.length) { const em = $('[data-wish-empty]'); em && (em.hidden = false); } }
  }, true);
  (function renderWishPage() {
    const grid = $('[data-wish-grid]'); if (!grid) return;
    const l = wGet(); const empty = $('[data-wish-empty]');
    if (!l.length) { empty && (empty.hidden = false); return; }
    const root = (A.routes && A.routes.root) || '/';
    Promise.all(l.map(h => fetch(root.replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '?view=wish').then(r => r.ok ? r.text() : '').catch(() => '')))
      .then(list => { grid.innerHTML = list.join(''); if (!grid.children.length && empty) empty.hidden = false; wSync(); });
  })();
  wSync();

  /* ---------- Skin advisor (sticky) ---------- */
  (function () {
    const root = $('[data-advisor]'); if (!root) return;
    const modal = $('[data-adv-modal]', root);
    const steps = $$('[data-adv-step]', root);
    const dots = $$('.adv-steps span', root);
    const skipSkin = root.dataset.skipSkin === '1' || !$('[data-adv-step="2"]', root);
    const size = Number(root.dataset.size || 3);
    const base = root.dataset.root || '';
    const skinPrefix = root.dataset.skinPrefix || 'skin-';
    const st = { concern: null, label: '', key: '', skin: '', skinKey: '', tip: '' };
    const cache = {};
    const money = c => (typeof formatMoney === 'function' ? formatMoney(c, A.moneyFormat) : (c / 100).toFixed(2));
    const esc = t => String(t || '').replace(/[&<>"']/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
    const tagCart = () => fetch(A.routes.cart_update + '.js', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'Skin advisor': st.label, 'Skin advisor key': st.key, 'Skin type': st.skin } }) }).catch(() => {});
    const track = (name, data) => {
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) { const r = Shopify.analytics.publish('avens:' + name, Object.assign({ concern: st.label, concern_key: st.key, skin_type: st.skin, page: location.pathname }, data || {})); r && r.catch && r.catch(() => {}); } } catch (_) {}
    };
    const stepIndex = n => (skipSkin && n === 3 ? 2 : n);
    const go = n => {
      steps.forEach(s => s.classList.toggle('is-active', s.dataset.advStep === String(n)));
      dots.forEach((d, i) => d.classList.toggle('is-on', i < stepIndex(n)));
      const p = $('.adv-modal__panel', modal); p && (p.scrollTop = 0);
    };
    const open = () => { track('advisor_open'); modal.hidden = false; document.documentElement.style.overflow = 'hidden'; requestAnimationFrame(() => modal.classList.add('is-open')); };
    const close = () => { modal.classList.remove('is-open'); document.documentElement.style.overflow = ''; setTimeout(() => (modal.hidden = true), 200); };
    const pick = (attr, el) => { $$('[' + attr + ']', root).forEach(c => { const on = c === el; c.classList.toggle('is-on', on); c.setAttribute('aria-checked', on); }); };
    const msg = t => { const m = $('[data-adv-msg]', root); if (!m) return; m.textContent = t || ''; m.hidden = !t; };
    const selectConcern = (el, via) => { st.concern = el.dataset.advConcern; st.key = el.dataset.advKey || ''; st.label = (el.textContent || '').trim(); pick('data-adv-concern', el); $('[data-adv-next]', root).disabled = false; track('advisor_concern', { via: via || 'click' }); };
    const selectSkin = el => { st.skin = el.dataset.advSkin; st.skinKey = el.dataset.advSkinKey || ''; st.tip = el.dataset.advTip; pick('data-adv-skin', el); const b = $('[data-adv-show]', root); b && (b.disabled = false); track('advisor_skin'); };

    async function feed(url) {
      if (cache[url]) return cache[url];
      cache[url] = fetch(url, { credentials: 'same-origin' }).then(r => (r.ok ? r.text() : '[]')).then(t => { try { return JSON.parse(t); } catch (_) { return []; } }).catch(() => []);
      return cache[url];
    }
    async function productsFor(r) {
      let list = [];
      const tag = r.dataset.srcTag, col = r.dataset.srcCol;
      if (tag) list = list.concat(await feed(base + '/collections/all/' + encodeURIComponent(tag) + '?view=advisor&sort_by=best-selling'));
      if (list.length < size && col) list = list.concat(await feed(base + '/collections/' + encodeURIComponent(col) + '?view=advisor&sort_by=best-selling'));
      const seen = {}; list = list.filter(p => p && p.available && p.variant && !seen[p.id] && (seen[p.id] = 1));
      if (st.skinKey) { const t = (skinPrefix + st.skinKey).toLowerCase(); list.sort((a, b) => (b.tags || []).map(x => x.toLowerCase()).includes(t) - (a.tags || []).map(x => x.toLowerCase()).includes(t)); }
      return list.slice(0, size);
    }
    function sumManual(r) {
      let total = 0; const ids = [];
      $$('[data-adv-list] li[data-variant]', r).forEach(li => { if (li.dataset.variant) { ids.push(li.dataset.variant); total += Number(li.dataset.price || 0); } });
      return { ids, total };
    }
    function setAll(r, ids, total) {
      const b = $('[data-adv-add-all]', r); if (!b) return;
      b.hidden = !ids.length; b.dataset.advAdd = ids.join(',');
      const t = $('[data-adv-total]', b); t && (t.textContent = money(total));
    }
    async function fill(r) {
      if (r.dataset.hasManual === '1') { const s = sumManual(r); setAll(r, s.ids, s.total); return; }
      const ol = $('[data-adv-list]', r);
      ol.innerHTML = '<li class="adv-loading"><span></span><span></span><span></span></li>';
      const list = await productsFor(r);
      if (!list.length) { ol.innerHTML = '<li class="adv-empty">' + esc(root.dataset.empty) + '</li>'; setAll(r, [], 0); return; }
      ol.innerHTML = list.map((p, i) => '<li><a href="' + esc(p.url) + '" class="adv-prod"><span class="adv-prod__n">' + (i + 1) + '</span><span class="adv-prod__img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="80" height="80">' : '') + '</span><span class="adv-prod__info"><span class="adv-prod__title">' + esc(p.title) + '</span><span class="adv-prod__price">' + money(p.price) + (p.compare > p.price ? ' <s>' + money(p.compare) + '</s>' : '') + '</span></span></a><button type="button" class="adv-prod__add" data-adv-add="' + p.variant + '" aria-label="' + esc(root.dataset.add) + '">+</button></li>').join('');
      setAll(r, list.map(p => p.variant), list.reduce((a, p) => a + p.price, 0));
    }
    function showResult() {
      $$('[data-adv-result]', root).forEach(r => {
        const on = r.dataset.advResult === st.concern; r.hidden = !on;
        if (!on) return;
        const so = $('[data-adv-skin-out]', r); so && (so.textContent = st.skin ? ' · ' + st.skin : '');
        const to = $('[data-adv-tip-out]', r); if (to) { to.textContent = st.tip || ''; to.hidden = !st.tip; }
        $$('.adv-bar__fill', r).forEach(f => { f.style.width = '0'; setTimeout(() => (f.style.width = 'var(--w)'), 60); });
        fill(r);
      });
      track('advisor_result');
      go(3);
    }

    document.addEventListener('click', e => {
      const o = e.target.closest('[data-adv-open], a[href$="#skin-advisor"]');
      if (o) { e.preventDefault(); open(); }
    });
    root.addEventListener('click', async e => {
      const t = e.target;
      if (t.closest('[data-adv-close]')) return close();
      const add = t.closest('[data-adv-add]');
      if (add && A.Cart) {
        e.preventDefault();
        const items = add.dataset.advAdd.split(',').filter(Boolean).map(id => ({ id: Number(id), quantity: 1 }));
        if (!items.length) return;
        add.classList.add('is-loading');
        try {
          track('advisor_add_to_cart', { variant_ids: items.map(i => i.id), items: items.length });
          await tagCart();
          if (items.length > 1 || add.matches('.btn')) close();
          await A.Cart.add(items, { source: add });
        } catch (err) { toast(err.message); }
        finally { add.classList.remove('is-loading'); }
        return;
      }
      const lk = t.closest('.adv-prod, .adv-cta a'); if (lk) { track('advisor_click', { url: lk.getAttribute('href') }); tagCart(); return; }
      const c = t.closest('[data-adv-concern]'); if (c) return selectConcern(c);
      const sk = t.closest('[data-adv-skin]'); if (sk) return selectSkin(sk);
      if (t.closest('[data-adv-next]')) return skipSkin ? showResult() : go(2);
      if (t.closest('[data-adv-back]') || t.closest('[data-adv-restart]')) return go(1);
      if (t.closest('[data-adv-show]')) return showResult();
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !modal.hidden) close(); });
    if (location.hash === '#skin-advisor') open();
    const pre = root.dataset.pre;
    if (pre) { const m = $$('[data-adv-concern]', root).find(c => c.dataset.advKey === pre); m && selectConcern(m, 'product_page'); }

    const file = $('[data-adv-file]', root);
    if (file) file.addEventListener('change', async () => {
      const f = file.files && file.files[0]; if (!f) return;
      const img = $('[data-adv-preview]', root); const empty = $('.adv-photo__empty', root);
      img.src = URL.createObjectURL(f); img.hidden = false; empty && (empty.hidden = true);
      const ep = root.dataset.endpoint;
      track('advisor_photo', { ai: !!ep });
      if (!ep) return;
      msg('…');
      try {
        const fd = new FormData(); fd.append('image', f); fd.append('locale', document.documentElement.lang || '');
        const r = await fetch(ep, { method: 'POST', body: fd }); const j = await r.json();
        const key = String(j.concern || '').toLowerCase();
        const match = $$('[data-adv-concern]', root).find(c => c.dataset.advKey === key);
        if (match) selectConcern(match, 'photo');
        const sk = String(j.skin || '').toLowerCase();
        const sm = $$('[data-adv-skin]', root).find(c => (c.dataset.advSkinKey || '').toLowerCase() === sk);
        if (sm) selectSkin(sm);
        msg(j.message || '');
      } catch (_) { msg(''); }
    });
  })();

  /* ---------- Image banner slider ---------- */
  $$('[data-bslider]').forEach(el => {
    const tr = $('[data-bs-track]', el); const dots = $$('[data-bs-dots] button', el); const n = dots.length; if (!tr || n < 2) return;
    let i = 0, t;
    const rtl = document.dir === 'rtl';
    const go = k => { i = (k + n) % n; tr.scrollTo({ left: (rtl ? -1 : 1) * i * tr.clientWidth, behavior: 'smooth' }); };
    const sync = () => { i = Math.round(Math.abs(tr.scrollLeft) / tr.clientWidth); dots.forEach((d, j) => d.classList.toggle('is-active', j === i)); };
    tr.addEventListener('scroll', () => { clearTimeout(tr._s); tr._s = setTimeout(sync, 60); });
    dots.forEach((d, j) => d.addEventListener('click', () => { go(j); restart(); }));
    const p = $('[data-bs-prev]', el), nx = $('[data-bs-next]', el);
    p && p.addEventListener('click', () => { go(i - 1); restart(); });
    nx && nx.addEventListener('click', () => { go(i + 1); restart(); });
    const sec = Number(el.dataset.autoplay || 0);
    const restart = () => { clearInterval(t); if (sec > 0) t = setInterval(() => { if (document.hidden) return; const r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return; go(i + 1); }, sec * 1000); };
    el.addEventListener('mouseenter', () => clearInterval(t)); el.addEventListener('mouseleave', restart);
    restart();
  });

  /* ---------- Carousel dots for .sc-wrap scrollers ---------- */
  $$('.sc-wrap').forEach(w => {
    const sc = $('.scroller', w); if (!sc || sc.children.length < 2) return;
    const box = document.createElement('div'); box.className = 'sc-dots'; w.after(box);
    const build = () => {
      const pages = Math.max(1, Math.ceil((sc.scrollWidth - 2) / sc.clientWidth));
      box.innerHTML = pages > 1 ? Array.from({ length: pages }, () => '<span></span>').join('') : '';
      upd();
    };
    const upd = () => { const ds = box.children; if (!ds.length) return; const k = Math.round(Math.abs(sc.scrollLeft) / sc.clientWidth); Array.from(ds).forEach((d, j) => d.classList.toggle('is-active', j === Math.min(k, ds.length - 1))); };
    sc.addEventListener('scroll', () => { clearTimeout(sc._d); sc._d = setTimeout(upd, 60); });
    window.addEventListener('resize', build); build();
  });

  /* ---------- Menu drawer / search ---------- */
  function closeMenu() { const m = $('#MenuDrawer'); if (m) { m.classList.remove('is-open'); document.documentElement.style.overflow = ''; } }
  document.addEventListener('click', e => {
    if (e.target.closest('[data-menu-open]')) { const m = $('#MenuDrawer'); m && m.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    if (e.target.closest('[data-menu-close]')) closeMenu();
    if (e.target.closest('[data-search-toggle]')) { const h = $('.header'); h.classList.toggle('search-open'); const i = $('.header__search input'); i && i.focus(); }
  });

  // Predictive search
  $$('[data-predictive]').forEach(wrap => {
    const input = $('input[name=q]', wrap); const out = $('.predictive', wrap);
    if (!input || !out) return;
    let tm;
    input.addEventListener('input', () => {
      clearTimeout(tm);
      const q = input.value.trim();
      if (q.length < 2) { out.hidden = true; return; }
      tm = setTimeout(async () => {
        try {
          const r = await fetch(`${A.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,article&resources[limit]=6`);
          const d = await r.json();
          const res = d.resources.results;
          const ps = res.products || [];
          if (!ps.length && !(res.collections || []).length) { out.innerHTML = `<div class="predictive__all">${wrap.dataset.empty || 'No results'}</div>`; out.hidden = false; return; }
          out.innerHTML = ps.map(p => `<a class="predictive__item" href="${p.url}">${p.image ? `<img src="${p.image}&width=120" alt="" loading="lazy">` : '<span></span>'}<span class="predictive__title">${p.title}</span><span class="predictive__price">${formatMoney(Math.round(parseFloat(p.price) * 100))}</span></a>`).join('')
            + (res.collections || []).slice(0, 3).map(c => `<a class="predictive__item" href="${c.url}"><span></span><span class="predictive__title">${c.title}</span><span></span></a>`).join('')
            + `<a class="predictive__all" href="${A.routes.search}?q=${encodeURIComponent(q)}">${wrap.dataset.all || 'View all results'} →</a>`;
          out.hidden = false;
        } catch (err) { out.hidden = true; }
      }, 250);
    });
    document.addEventListener('click', e => { if (!wrap.contains(e.target)) out.hidden = true; });
  });

  /* ---------- Read more ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-clamp-toggle]'); if (!b) return;
    const c = document.getElementById(b.dataset.clampToggle); if (!c) return;
    const open = c.classList.toggle('is-open');
    b.textContent = open ? (b.dataset.less || A.strings.readLess) : (b.dataset.more || A.strings.readMore);
  });

  /* ---------- Product: gallery + variants ---------- */
  function initProduct(scope = document) {
    $$('[data-product]', scope).forEach(p => {
      if (p._init) return; p._init = true;
      const gal = $('[data-gallery]', p);
      const showMedia = (id) => {
        if (!gal) return;
        const slides = $$('.gallery__slide', gal), thumbs = $$('.gallery__thumb', gal);
        let idx = slides.findIndex(s => s.dataset.mediaId === String(id));
        if (idx < 0) idx = Number(id) || 0;
        if (!slides[idx]) return;
        slides.forEach((s, k) => { s.classList.toggle('is-active', k === idx); if (k !== idx) $$('video', s).forEach(v => v.pause()); });
        thumbs.forEach((t, k) => t.classList.toggle('is-active', k === idx));
      };
      gal && gal.addEventListener('click', e => { const t = e.target.closest('.gallery__thumb'); if (t) showMedia(t.dataset.index); });
      if (gal) { let x0 = null; const main = $('.gallery__main', gal);
        main && main.addEventListener('touchstart', e => (x0 = e.touches[0].clientX), { passive: true });
        main && main.addEventListener('touchend', e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { const slides = $$('.gallery__slide', gal); const cur = slides.findIndex(s => s.classList.contains('is-active')); const rtl = document.dir === 'rtl'; showMedia((cur + ((dx < 0) !== rtl ? 1 : -1) + slides.length) % slides.length); } x0 = null; }); }

      const jsonEl = $('[data-variants-json]', p);
      if (!jsonEl) return;
      const variants = JSON.parse(jsonEl.textContent);
      const form = $('form[data-product-form]', p);
      const idInput = form && $('input[name=id]', form);
      const qtyInput = $('[data-qty-input]', p);
      const getOpts = () => {
        const groups = $$('[data-option-index]', p);
        return groups.map(g => { const c = $('input:checked', g) || $('select', g); return c ? c.value : null; });
      };
      const update = (variant) => {
        if (!variant) {
          $$('[data-atc]', p).forEach(b => { b.disabled = true; $('[data-atc-label]', b) && ($('[data-atc-label]', b).textContent = A.strings.unavailable); });
          return;
        }
        if (idInput) idInput.value = variant.id;
        $$('input[name=id]', document).forEach(i => { if (i.closest('[data-sticky-form]') || i.closest('[data-buy-form]')) i.value = variant.id; });
        const q = qtyInput ? Math.max(1, Number(qtyInput.value || 1)) : 1;
        const price = formatMoney(variant.price * q);
        const cmp = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price * q) : '';
        $$('[data-price]').forEach(el => (el.textContent = price));
        $$('[data-compare]').forEach(el => { el.textContent = cmp; el.hidden = !cmp; });
        const pct = variant.compare_at_price > variant.price ? Math.round((1 - variant.price / variant.compare_at_price) * 100) : 0;
        const save = variant.compare_at_price > variant.price ? formatMoney((variant.compare_at_price - variant.price) * q) : '';
        $$('[data-save-badge]').forEach(el => { const tpl = el.dataset.tpl || '[percent]%'; el.textContent = tpl.replace('[percent]', pct).replace('[amount]', save); el.hidden = !pct; });
        $$('[data-atc]').forEach(b => {
          b.disabled = !variant.available;
          const l = $('[data-atc-label]', b) || b;
          const base = b.dataset.label || A.strings.addToCart;
          l.textContent = variant.available ? base.replace('[price]', price) : A.strings.soldOut;
        });
        $$('[data-sku]', p).forEach(el => (el.textContent = variant.sku || ''));
        $$('.tier', p).forEach(t => { const inp = $('input', t); t.classList.toggle('is-active', inp && inp.checked); });
        if (variant.featured_media) showMedia(variant.featured_media.id);
        if (p.dataset.updateUrl !== 'false' && !p.closest('[data-no-url]')) {
          const u = new URL(window.location.href); u.searchParams.set('variant', variant.id); window.history.replaceState({}, '', u.toString());
        }
        p.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
      };
      p._update = () => { const o = getOpts(); if (!o.length) { update(variants.find(v => String(v.id) === (idInput && idInput.value)) || variants[0]); return; } update(variants.find(v => v.options.every((x, k) => x === o[k]))); };
      p.addEventListener('change', e => { if (e.target.closest('[data-option-index]') || e.target === qtyInput) p._update(); });
      const initial = variants.find(v => String(v.id) === (idInput && idInput.value));
      if (initial) update(initial);
    });
  }
  initProduct();

  /* ---------- Frequently bought together ---------- */
  function initFbt(scope = document) {
    $$('[data-fbt]', scope).forEach(box => {
      if (box._init) return; box._init = true;
      const calc = () => {
        let tot = 0, was = 0, n = 0;
        $$('.fbt__item', box).forEach(it => {
          const on = $('input', it).checked; it.classList.toggle('is-off', !on);
          if (on) { tot += Number(it.dataset.amount); was += Number(it.dataset.cmp || it.dataset.amount); n++; }
        });
        $('[data-fbt-total]', box).textContent = formatMoney(tot);
        const w = $('[data-fbt-was]', box); if (w) { w.textContent = was > tot ? formatMoney(was) : ''; }
        const b = $('[data-fbt-add]', box); b.textContent = (b.dataset.tpl || 'Add [count] to cart').replace('[count]', n); b.disabled = !n;
        const note = $('[data-fbt-note]', box);
        if (note) {
          const goal = Number(note.dataset.goal), cart = Number(note.dataset.cart);
          const rem = goal - cart - tot;
          note.textContent = rem <= 0 ? note.dataset.done : note.dataset.before.replace('[remaining]', formatMoney(rem));
        }
      };
      box.addEventListener('change', calc);
      $('[data-fbt-add]', box).addEventListener('click', async (e) => {
        const b = e.currentTarget; b.classList.add('is-loading');
        const items = $$('.fbt__item', box).filter(it => $('input', it).checked).map(it => ({ id: Number(it.dataset.variant), quantity: 1 }));
        try { await Cart.add(items, { source: b }); } catch (err) { toast(err.message); } finally { b.classList.remove('is-loading'); }
      });
      calc();
    });
  }
  initFbt();

  /* ---------- Before / after ---------- */
  document.addEventListener('input', e => {
    const r = e.target.closest('[data-ba-range]'); if (!r) return;
    const ba = r.closest('.ba'); ba.style.setProperty('--pos', r.value + '%');
    // BEFORE / AFTER tags fade out as the divider moves over their side
    const f = (d) => Math.max(0, Math.min(1, (d - 8) / 17));
    const t = ba.querySelectorAll('.rcard__tag');
    if (t[0]) t[0].style.opacity = f(Number(r.value));
    if (t[1]) t[1].style.opacity = f(100 - Number(r.value));
  });

  /* ---------- Video: modal / inline ---------- */
  function closeVideo() { const m = $('.video-modal'); m && m.remove(); }
  document.addEventListener('click', e => {
    let b = e.target.closest('[data-video]');
    if (!b) { const hostEl = e.target.closest('.svid__media, .vcard, [data-video-click]'); if (hostEl) b = hostEl.querySelector('[data-video]'); }
    if (!b) return;
    e.preventDefault();
    const src = b.dataset.video; if (!src) return;
    const mode = b.dataset.videoMode || 'modal';
    let html, vertical = !!b.dataset.vertical;
    const yt = src.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|shorts\/|embed\/))([\w-]{6,})/);
    const vm = src.match(/vimeo\.com\/(\d+)/);
    const ig = src.match(/instagram\.com\/(?:[\w.]+\/)?(?:reel|reels|p|tv)\/([\w-]+)/);
    const tt = src.match(/tiktok\.com\/.*video\/(\d+)/);
    if (yt) { vertical = /shorts\//.test(src); html = `<iframe src="https://www.youtube.com/embed/${yt[1]}?autoplay=1&rel=0&playsinline=1" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe>`; }
    else if (vm) { vertical = false; html = `<iframe src="https://player.vimeo.com/video/${vm[1]}?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>`; }
    else if (ig) { vertical = true; html = `<iframe class="is-social" src="https://www.instagram.com/reel/${ig[1]}/embed" allow="autoplay; encrypted-media; fullscreen" allowfullscreen scrolling="no"></iframe>`; }
    else if (tt) { vertical = true; html = `<iframe class="is-social" src="https://www.tiktok.com/embed/v2/${tt[1]}" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe>`; }
    else html = `<video src="${src}" controls autoplay playsinline></video>`;
    if (mode === 'inline') {
      const host = b.closest('[data-video-host]') || b.parentElement;
      const div = document.createElement('div'); div.className = 'video-inline'; div.innerHTML = html;
      const el = div.firstElementChild; el.className = 'video-inline'; host.appendChild(el); b.hidden = true;
      return;
    }
    closeVideo();
    const m = document.createElement('div'); m.className = 'video-modal';
    m.innerHTML = `<div class="video-modal__inner${vertical ? ' video-modal__inner--vertical' : ''}"><button class="video-modal__close" aria-label="Close">✕</button>${html}</div>`;
    m.addEventListener('click', ev => { if (ev.target === m || ev.target.closest('.video-modal__close')) closeVideo(); });
    document.body.appendChild(m);
  });

  /* ---------- Tabs (FAQ categories, blog tabs etc.) ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-tab]'); if (!b) return;
    const wrap = b.closest('[data-tabs]'); if (!wrap) return;
    e.preventDefault();
    $$('[data-tab]', wrap).forEach(x => x.classList.toggle('is-active', x === b));
    $$('[data-panel]', wrap).forEach(p => (p.hidden = p.dataset.panel !== b.dataset.tab));
    const s = $('[data-faq-search]', wrap); if (s) s.value = '';
    $$('[data-faq-item]', wrap).forEach(i => (i.hidden = false));
  });

  /* ---------- FAQ search ---------- */
  document.addEventListener('input', e => {
    const s = e.target.closest('[data-faq-search]'); if (!s) return;
    const wrap = s.closest('[data-tabs]') || s.closest('section');
    const q = s.value.trim().toLowerCase();
    const panels = $$('[data-panel]', wrap);
    if (!q) {
      const act = $('[data-tab].is-active', wrap);
      panels.forEach(p => (p.hidden = act ? p.dataset.panel !== act.dataset.tab : false));
      $$('[data-faq-item]', wrap).forEach(i => (i.hidden = false));
      $$('[data-tab]', wrap).forEach(t => t.classList.toggle('is-dim', false));
      return;
    }
    panels.forEach(p => (p.hidden = false));
    $$('[data-faq-item]', wrap).forEach(i => (i.hidden = !i.textContent.toLowerCase().includes(q)));
    $$('[data-tab]', wrap).forEach(t => t.classList.remove('is-active'));
  });

  /* ---------- Reviews list: search / filter / sort / more ---------- */
  $$('[data-reviews]').forEach(box => {
    const items = $$('[data-review]', box);
    const list = $('[data-review-list]', box);
    const empty = $('[data-review-empty]', box);
    const more = $('[data-review-more]', box);
    const step = Number(box.dataset.step || 4);
    let shown = step, filter = 'all';
    const apply = () => {
      const q = ($('[data-review-search]', box) || { value: '' }).value.trim().toLowerCase();
      const sort = ($('[data-review-sort]', box) || { value: 'new' }).value;
      let vis = items.filter(it => (filter === 'all' || (it.dataset.tags || '').split('|').includes(filter)) && (!q || it.textContent.toLowerCase().includes(q)));
      vis.sort((a, b) => sort === 'old' ? a.dataset.date - b.dataset.date : sort === 'helpful' ? b.dataset.helpful - a.dataset.helpful : b.dataset.date - a.dataset.date);
      items.forEach(it => (it.hidden = true));
      vis.forEach((it, k) => { list.appendChild(it); it.hidden = k >= shown; });
      if (empty) empty.hidden = vis.length > 0;
      if (more) more.hidden = vis.length <= shown;
    };
    box.addEventListener('click', e => {
      const f = e.target.closest('[data-review-filter]');
      if (f) { filter = f.dataset.reviewFilter; shown = step; $$('[data-review-filter]', box).forEach(x => x.classList.toggle('is-active', x === f && filter !== 'all' || (filter === 'all' && x.dataset.reviewFilter === 'all'))); if (f.hasAttribute('data-clear')) { const s = $('[data-review-search]', box); if (s) s.value = ''; } apply(); }
      if (e.target.closest('[data-review-more]')) { shown += step; apply(); }
      const v = e.target.closest('[data-vote]');
      if (v && !v.classList.contains('is-voted')) { const c = $('span', v); c.textContent = Number(c.textContent) + 1; v.classList.add('is-voted'); $$('[data-vote]', v.parentElement).forEach(x => (x.disabled = true)); }
      if (e.target.closest('[data-review-write]')) { const m = $('[data-review-modal]', box); if (m) m.hidden = false; }
      if (e.target.closest('[data-review-modal-close]') || e.target.matches('[data-review-modal]')) { const m = $('[data-review-modal]', box); if (m) m.hidden = true; }
    });
    box.addEventListener('input', e => { if (e.target.matches('[data-review-search]')) { shown = step; apply(); } });
    box.addEventListener('change', e => { if (e.target.matches('[data-review-sort]')) apply(); });
    if (items.length) apply();
  });

  /* ---------- Sticky add to cart ---------- */
  function initSticky() {
    const bar = $('[data-sticky-atc]'); if (!bar) return;
    const target = $('[data-product-form]') || $('[data-product]');
    document.body.classList.add('has-sticky-atc');
    if (!target || !('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }
    const always = bar.dataset.always === 'true';
    if (always) { bar.classList.add('is-visible'); return; }
    new IntersectionObserver(([en]) => bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(target);
  }
  initSticky();

  /* ---------- Collection filters ---------- */
  function closeFacets() { const f = $('.facets-wrap'); if (f) { f.classList.remove('is-open'); document.documentElement.style.overflow = ''; } }
  document.addEventListener('click', e => {
    if (e.target.closest('[data-facets-open]')) { const f = $('.facets-wrap'); f && f.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    if (e.target.closest('[data-facets-close]')) closeFacets();
  });
  document.addEventListener('change', e => {
    const f = e.target.closest('form[data-facets-form]');
    if (f && !e.target.matches('[data-price-input]')) submitFacets(f);
    const sort = e.target.closest('[data-sort]');
    if (sort) { const u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); window.location.href = u.toString(); }
  });
  document.addEventListener('submit', e => { const f = e.target.closest('form[data-facets-form]'); if (f) { e.preventDefault(); submitFacets(f); } });
  /* ---------- Facet "show more" + grid/list view ---------- */
  document.addEventListener('click', e => {
    const m = e.target.closest('[data-facet-more]');
    if (m) {
      const body = m.closest('.facet__body'); const open = body.classList.toggle('is-expanded');
      const sp = m.querySelector('span'); if (!m.dataset.more) m.dataset.more = sp.textContent;
      sp.textContent = open ? (m.dataset.less || m.dataset.more) : m.dataset.more;
    }
    const vb = e.target.closest('[data-view]');
    if (vb) setView(vb.dataset.view, true);
  });
  function setView(v, save) {
    const g = $('[data-coll-grid]'); if (!g) return;
    g.classList.toggle('is-list', v === 'list');
    document.querySelectorAll('[data-view]').forEach(b => { const on = b.dataset.view === v; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
    if (save) { try { localStorage.setItem('avens-view', v); } catch (_) {} }
  }
  try { const v = localStorage.getItem('avens-view'); if (v) setView(v, false); } catch (_) {}

  function submitFacets(form) {
    const params = new URLSearchParams(new FormData(form));
    for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
    const cur = new URL(window.location.href); const s = cur.searchParams.get('sort_by'); if (s) params.set('sort_by', s);
    window.location.href = window.location.pathname + '?' + params.toString();
  }

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', e => { initSliders(e.target); initProduct(e.target); initFbt(e.target); });
  document.addEventListener('shopify:section:select', e => { if (e.target.querySelector('#CartDrawer')) Cart.open(); });
})();

/* Product recommendations loader */
(function () {
  document.querySelectorAll('[data-recs]').forEach(async el => {
    try {
      const r = await fetch(el.dataset.recs);
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[id^="Scroller-"]');
      const mine = el.querySelector('[id^="Scroller-"]');
      if (inner && inner.children.length && mine) mine.innerHTML = inner.innerHTML;
      else if (!mine || !mine.children.length) el.closest('section') && (el.closest('section').hidden = true);
    } catch (e) {}
  });
})();

/* Carousels (cart drawer cross-sell, cart page upsells) */
(function () {
  const rtl = () => document.dir === 'rtl';
  function setup(c) {
    if (c._car) { c._update && c._update(); return; } c._car = true;
    const track = c.querySelector('[data-car-track]'); if (!track) return;
    const prev = c.querySelector('[data-car-prev]'), next = c.querySelector('[data-car-next]');
    const dotsWrap = c.querySelector('[data-car-dots]');
    const step = () => { const it = track.firstElementChild; if (!it) return track.clientWidth; const gap = parseFloat(getComputedStyle(track).columnGap) || 10; return it.getBoundingClientRect().width + gap; };
    const pages = () => Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / step()) + 1);
    const pos = () => Math.abs(track.scrollLeft);
    const maxPos = () => track.scrollWidth - track.clientWidth;
    const go = dir => track.scrollBy({ left: dir * step() * (rtl() ? -1 : 1), behavior: 'smooth' });
    function update() {
      const stat = maxPos() <= 2;
      c.classList.toggle('is-static', stat);
      if (prev) prev.disabled = pos() <= 2;
      if (next) next.disabled = pos() >= maxPos() - 2;
      if (dotsWrap) {
        const n = pages();
        if (dotsWrap.children.length !== n) { dotsWrap.innerHTML = ''; for (let i = 0; i < n; i++) { const b = document.createElement('button'); b.type = 'button'; b.className = 'carousel__dot'; b.setAttribute('aria-label', i + 1); b.addEventListener('click', () => track.scrollTo({ left: i * step() * (rtl() ? -1 : 1), behavior: 'smooth' })); dotsWrap.appendChild(b); } }
        const cur = Math.round(pos() / step());
        Array.from(dotsWrap.children).forEach((d, i) => d.classList.toggle('is-active', i === Math.min(cur, n - 1)));
      }
    }
    prev && prev.addEventListener('click', () => go(-1));
    next && next.addEventListener('click', () => go(1));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    const secs = Number(c.dataset.autoplay || 0);
    if (secs > 0) {
      let t; const start = () => { clearInterval(t); t = setInterval(() => { if (!document.body.contains(track)) return clearInterval(t); if (document.hidden) return; { const r = c.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return; } if (pos() >= maxPos() - 2) track.scrollTo({ left: 0, behavior: 'smooth' }); else go(1); }, secs * 1000); };
      c.addEventListener('mouseenter', () => clearInterval(t)); c.addEventListener('mouseleave', start);
      track.addEventListener('touchstart', () => clearInterval(t), { passive: true }); track.addEventListener('touchend', () => { clearTimeout(c._rt); c._rt = setTimeout(start, 2500); }, { passive: true });
      start();
    }
    c._update = update;
    update(); setTimeout(update, 400);
  }
  const init = () => document.querySelectorAll('[data-carousel]').forEach(setup);
  init();
  document.addEventListener('cart:updated', init);
  document.addEventListener('shopify:section:load', init);
  // drawer content is hidden until opened — recalc when it opens
  const d = document.getElementById('CartDrawer');
  if (d) new MutationObserver(() => setTimeout(() => document.querySelectorAll('#CartDrawer [data-carousel]').forEach(setup), 380)).observe(d, { attributes: true, attributeFilter: ['class'] });
})();

/* Quantity offers */
(function () {
  const fm = c => (window.Avens.formatMoney ? window.Avens.formatMoney(c) : c);
  document.querySelectorAll('[data-qbreaks]').forEach(box => {
    const p = box.closest('[data-product]') || document;
    const qty = p.querySelector('[data-qty-input]');
    let price = null, cmp = null;
    const sync = () => {
      box.querySelectorAll('.tier').forEach(t => t.classList.toggle('is-active', t.querySelector('input').checked));
    };
    box.addEventListener('change', e => {
      const t = e.target.closest('.tier'); if (!t) return;
      sync();
      if (qty) { qty.value = t.dataset.q; qty.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    if (qty) qty.addEventListener('change', () => {
      box.querySelectorAll('.tier').forEach(t => { const inp = t.querySelector('input'); inp.checked = t.dataset.q === String(qty.value); });
      sync();
    });
    p.addEventListener('variant:change', e => {
      const v = e.detail.variant; price = v.price; cmp = v.compare_at_price;
      box.querySelectorAll('.tier').forEach(t => {
        const q = Number(t.dataset.q), pct = Number(t.dataset.pct);
        const now = Math.round(price * q * (1 - pct / 100)), was = (cmp > price ? cmp : price) * q;
        const n = t.querySelector('[data-qb-now]'), w = t.querySelector('[data-qb-was]');
        if (n) n.textContent = fm(now); if (w) { w.textContent = was > now ? fm(was) : ''; }
      });
    });
    const first = box.querySelector('.tier input:checked');
    if (first && qty && Number(qty.value) !== Number(first.value)) { qty.value = first.value; qty.dispatchEvent(new Event('change', { bubbles: true })); }
  });
})();

/* ---- Contact form → WhatsApp (contact-split "Open WhatsApp" mode) ---- */
(function () {
  document.addEventListener('submit', function (e) {
    const form = e.target;
    const btn = form.querySelector && form.querySelector('[data-wa-submit]');
    if (!btn) return;
    e.preventDefault();
    if (form.reportValidity && !form.reportValidity()) return;
    const lines = [];
    if (btn.dataset.waIntro) lines.push(btn.dataset.waIntro, '');
    form.querySelectorAll('[data-wa-label]').forEach(function (el) {
      const v = (el.value || '').trim();
      if (v) lines.push('• ' + el.dataset.waLabel + ': ' + v);
    });
    const text = encodeURIComponent(lines.join('\n'));
    const num = btn.dataset.waNumber || '';
    const win = window.open('https://wa.me/' + num + '?text=' + text, '_blank', 'noopener');
    if (!win) window.location.href = 'https://api.whatsapp.com/send?phone=' + num + '&text=' + text;
  });
})();

/* ---- Policy page: highlight current clause in the table of contents ---- */
(function () {
  const tocs = document.querySelectorAll('[data-policy-toc]');
  if (!tocs.length || !('IntersectionObserver' in window)) return;
  tocs.forEach(function (toc) {
    const links = toc.querySelectorAll('a[href^="#"]');
    const map = {};
    links.forEach(function (a) { const el = document.getElementById(a.getAttribute('href').slice(1)); if (el) map[el.id] = a; });
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { links.forEach(function (l) { l.classList.remove('is-active'); }); map[en.target.id] && map[en.target.id].classList.add('is-active'); }
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    Object.keys(map).forEach(function (id) { io.observe(document.getElementById(id)); });
  });
})();

/* ---- Search suggestions panel (opens when the search is tapped; header → "Search suggestions") ---- */
(function () {
  document.querySelectorAll('[data-search-sugg]').forEach(function (panel) {
    var form = panel.closest('form'); if (!form) return;
    var input = form.querySelector('input[name=q]'); if (!input) return;
    var pred = form.querySelector('.predictive');
    var KEY = 'avens-recent-searches';
    var recentBox = panel.querySelector('[data-sugg-recent]'), recentList = panel.querySelector('[data-sugg-recent-list]');
    var read = function () { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
    var write = function (a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} };
    var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    function renderRecent() {
      if (!recentBox) return;
      var list = read();
      recentBox.hidden = !list.length;
      recentList.innerHTML = list.map(function (q) { return '<a class="ssugg__chip" href="' + form.getAttribute('action') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">↺ ' + esc(q) + '</a>'; }).join('');
    }
    function show() { if (input.value.trim()) return; renderRecent(); panel.hidden = false; if (pred) pred.hidden = true; form.classList.add('is-sugg'); }
    function hide() { panel.hidden = true; form.classList.remove('is-sugg'); }
    input.addEventListener('focus', show);
    input.addEventListener('click', show);
    input.addEventListener('input', function () { if (input.value.trim()) hide(); else show(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { hide(); input.blur(); } });
    form.addEventListener('submit', function () {
      var q = input.value.trim(); if (!q) return;
      var list = read().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); list.unshift(q); write(list.slice(0, 6));
    });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-sugg-clear]')) { e.preventDefault(); write([]); renderRecent(); input.focus(); return; }
      var chip = e.target.closest('[data-sugg-q]');
      if (chip) { var list = read().filter(function (x) { return x !== chip.dataset.suggQ; }); list.unshift(chip.dataset.suggQ); write(list.slice(0, 6)); }
      if (e.target.closest('[data-ai-open],[data-img-search]')) hide();
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
  });
})();

/* WhatsApp chat popup: write the message here, then continue on WhatsApp */
(function () {
  var pop = document.querySelector('[data-wa-pop]');
  if (!pop) return;
  var btns = document.querySelectorAll('[data-wa-open]');
  var input = pop.querySelector('[data-wa-input]');
  var form = pop.querySelector('[data-wa-form]');
  var rtl = document.documentElement.dir === 'rtl';
  var last = null;
  function place(btn) {
    var r = btn.getBoundingClientRect();
    var icon = btn.querySelector('.wa-float__icon') || btn;
    var ir = icon.getBoundingClientRect();
    pop.style.setProperty('--wa-pop-bottom', Math.max(12, window.innerHeight - ir.top + 12) + 'px');
    var start = rtl ? window.innerWidth - ir.right : ir.left;
    var w = Math.min(340, window.innerWidth - 28);
    start = Math.min(Math.max(14, start), window.innerWidth - w - 14);
    pop.style.setProperty('--wa-pop-start', start + 'px');
  }
  function open(btn) {
    last = btn; place(btn);
    pop.hidden = false;
    btns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }, 60);
  }
  function close() {
    pop.hidden = true;
    btns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (last) last.focus();
  }
  btns.forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (pop.hidden) open(b); else close();
    });
  });
  pop.querySelector('[data-wa-close]').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
  document.addEventListener('click', function (e) {
    if (pop.hidden) return;
    if (pop.contains(e.target) || e.target.closest('[data-wa-open]')) return;
    close();
  });
  window.addEventListener('resize', function () { if (!pop.hidden && last) place(last); });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var msg = (input.value || '').trim() || pop.getAttribute('data-wa-default') || '';
    var url = pop.getAttribute('data-wa-url') + (msg ? '?text=' + encodeURIComponent(msg) : '');
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('avens_whatsapp_chat', { message: msg, page: location.pathname }); } catch (err) {}
    var w = window.open(url, '_blank');
    if (w) { try { w.opener = null; } catch (err) {} } else { location.href = url; }
    input.value = '';
    close();
  });
})();

/* Read more: hide the button when the text already fits */
(function () {
  function check() {
    document.querySelectorAll('[data-clamp-toggle]').forEach(function (b) {
      var c = document.getElementById(b.getAttribute('data-clamp-toggle'));
      if (!c || !c.classList.contains('clamp') || c.classList.contains('is-open')) return;
      b.hidden = c.scrollHeight <= c.clientHeight + 2;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
  window.addEventListener('load', check);
  window.addEventListener('resize', function () { clearTimeout(check._t); check._t = setTimeout(check, 150); });
})();

/* Rating link under the product title: scroll to the reviews and, for "Be the first to review", open the write-a-review form */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-write-review], a[data-go-reviews], .pinfo__rating a');
    if (!a) return;
    var box = document.getElementById('reviews') || document.querySelector('[data-review-write]') || document.querySelector('.reviews-cta, [id*="reviews"]');
    if (!box) return;
    e.preventDefault();
    var sec = box.closest('section') || box;
    sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (a.hasAttribute('data-write-review')) {
      var w = sec.querySelector('[data-review-write]') || document.querySelector('[data-review-write]');
      if (w) setTimeout(function () { if (w.tagName === 'A') { location.href = w.href; } else { w.click(); } }, 450);
    }
  });
})();